export enum PermissionList {
	MaterialStatus = 'MaterialStatus',
	NewsStatus = 'NewsStatus',
	ForecastStatus = 'ForecastStatus',
	PdfModuleStatus = 'PdfModuleStatus'
}
